module.exports = __webpack_public_path__ + "4a754b5c4d920c27847086c890c1aec1.pdf";